import React, { useState } from 'react';
import { Button, Modal } from 'ui/atoms';

import ImageFailure from './image-failure';
import './conversation-response-image.css';

const ConversationResponseImage = ({ src }) => {
  const [openImage, setOpenImage] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div className="conversation-response-image-row">
      <div className="image-wrapper">
        <Button
          onClick={() => setOpenImage(true)}
          className="image-button"
          role="button"
          aria-label="full-size-image"
          shape={undefined}
        >
          {!imageError && (
            <>
              {!imageLoaded && (
                <div className="image-placeholder" aria-hidden="true" />
              )}
              <img
                src={src}
                alt="Response"
                className={imageLoaded ? 'image-loaded' : 'image-loading'}
                onError={() => setImageError(true)}
                onLoad={() => {
                  setImageLoaded(true);
                  setImageError(false);
                }}
              />
            </>
          )}
          {imageError && <ImageFailure />}
        </Button>
      </div>
      <Modal
        open={openImage}
        title={''}
        footer={[]}
        className="conversation-response-image-modal"
        onCancel={() => {
          setOpenImage(false);
        }}
      >
        <img className="full-size" src={src} alt="Response" />
      </Modal>
    </div>
  );
};

export default ConversationResponseImage;
